
import { singularityStore, uiStore } from "@/store/store";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import SingularityCanvasButton from "../OverlaidUI/Singularity/components/SingularityCanvasButton.vue";
import SingularitySectionLibraryModal from "../../Singularity/SingularitySectionLibraryModal/SingularitySectionLibraryModal.vue";
import SingularityCanvasOption from "../../Singularity/components/SingularityCanvasOption.vue";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    SingularityCanvasButton,
    SingularitySectionLibraryModal,
    Icon,
    SingularityCanvasOption
  }
})
export default class EmptyContainer extends Vue {
  @Prop({ default: null })
  id!: number | null;

  get canAddElement() {
    return uiStore.hasFullAccess;
  }

  isModalOpen = false;

  openSectionLibraryModal() {
    singularityStore.setSectionLibraryModalState(true);
  }

  openPagesManager() {
    singularityStore.setSingularityLeftPanel("page_manager");
    singularityStore.highlightSingularityLeftPanel();
  }

  openAddNewSectionAI() {
    singularityStore.setAddNewSectionPanelState({
      mode: "breakdance_ai"
    });
    singularityStore.highlightSingularityLeftPanel();
  }
}
